module.exports = __webpack_public_path__ + "img/koenen3-min.75f64346.jpg";